enum TeamMemberRole {
  PI = 'Principle Investigator',
  LEAD_ARCHITECT = 'Lead Software Architect',
  DATA_REPO_LEAD = 'Data Repository Lead',
  SOFTWARE_ENGINEER = 'Software Engineer',
  UX_ENGINEER = 'UX Engineer',
  CLOUD_ADVISOR = 'Senior Cloud Advisor',
  LEAD_DEVELOPER = 'Lead Developer',
}

export default TeamMemberRole;
